import { IScreen } from './iScreen';

class CutSceneScreen implements IScreen{
    video: any;

    constructor(){
        
    }

    setup(){
        
    }

    windowResized(): void {
        
    }

    loadVideo(name: string){
        console.log('Loading video');
        this.video = p5js.createVideo([`${staticServer}/assets/videos/${name}.mp4`]);
        this.video.hide();
        this.video.noLoop();
        this.video.autoplay(true);
        this.video.onended(() => {
            console.log('Video ended');
            currentScreen = "game";
            iScreen = screens[currentScreen];
            this.video.remove();
        });
    }

    draw(){
        buffer.background(0);

        if(this.video){
            let w = this.video.width;
            let h = this.video.height;
            
            let scale = p5js.int(buffer.width / w);

            buffer.imageMode(buffer.CENTER);
            buffer.noSmooth();
            buffer.image(this.video, 0, 0, w * scale, h * scale);
            buffer.imageMode(buffer.CORNER);
        }else{
            buffer.textAlign(buffer.CENTER, buffer.CENTER);
            buffer.fill(255);
            buffer.textSize(15);
            buffer.noStroke();
            buffer.text("Loading...", 0, 0);
        }

    }

    keyPressed(){
        if(p5js.keyCode === p5js.ESCAPE){
            currentScreen = "mainMenu";
            iScreen = screens[currentScreen];
            //iScreen = new MainMenuScreen(p5js);
            return;
        }
    }

    keyReleased(){
        
    }

    mousePressed(){
        
    }

    mouseReleased(){
        
    }

    touchStarted(){
        
    }

    touchEnded(){
        
    }

    touchMoved(): void {
        
    }

    mouseWheel(event: any): void {
        
    }

}

export default CutSceneScreen;